import { REACT_APP_API_URL } from "../../setup/config";
import axios, { handleApiError } from '../axios';

export const getSellerGRNQCPunchs = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/seller-grn-qc-punch/`, data);
        return await response.data;
    } catch (error) {
        console.log("getSellerGRNQCPunchs - error", error)
        return handleApiError(error)
    }
}

export const getSellerGRNQCPunchById = async (sellerGRNQCPunchId) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/seller-grn-qc-punch/${sellerGRNQCPunchId}`);
        return await response.data;
    } catch (error) {
        console.log("getSellerGRNQCPunchById - error", error)
        return handleApiError(error)
    }
}

export const insertSellerGRNQCPunch = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/seller-grn-qc-punch/create`, data);
        return await response.data;
    } catch (error) {
        console.log("insertSellerGRNQCPunch - error", error)
        return handleApiError(error)
    }
}

export const getsellerGRNQCPunchAcceptedQty = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/seller-grn-qc-punch/sellerGRNQCPunchAcceptedQty`, data);
        return await response.data;
    } catch (error) {
        console.log("getsellerGRNQCPunchAcceptedQty - error", error)
        return handleApiError(error)
    }
}

export const getsellerGRNQCPunchAcceptedQtyForCreateDispatchNote = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/seller-grn-qc-punch/sellerGRNQCPunchAcceptedQtyForCreateDispatchNote`, data);
        return await response.data;
    } catch (error) {
        console.log("sellerGRNQCPunchAcceptedQtyForCreateDispatchNote - error", error)
        return handleApiError(error)
    }
}

export const getSellerGRNQCPunchAcceptedQtyByDispatchIds = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/seller-grn-qc-punch/sellerGRNQCPunchAcceptedQtyByDispatchIds`, data);
        return await response.data;
    } catch (error) {
        console.log("getSellerGRNQCPunchAcceptedQtyByDispatchIds - error", error)
        return handleApiError(error)
    }
}

export const getSellerGRNQCPunchesByBuyerReqIds = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/seller-grn-qc-punch/sellerGRNQCPunchByBuyerReqIds`, data);
        return await response.data;
    } catch (error) {
        console.log("getSellerGRNQCPunchesByBuyerReqIds - error", error)
        return handleApiError(error)
    }
}

export const cancelSellerGRNQCPunchBySellerPIPunchId = async (sellerPIPunchId, data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/seller-grn-qc-punch/update/sellerPIPunchId/${sellerPIPunchId}`, data);
        return await response.data;
    } catch (error) {
        console.log("cancelSellerGRNQCPunchBySellerPIPunchId - error", error)
        return handleApiError(error)
    }
}

export const getLatestSellerGRNQCPunchesBySellerPODocNos = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/seller-grn-qc-punch/sellerGRNQCPunchBySellerPODocNos`, data);
        return await response.data;
    } catch (error) {
        console.log("getLatestSellerGRNQCPunchesBySellerPODocNos - error", error)
        return handleApiError(error)
    }
}

export const getSellerGRNQCPunchByDocNo = async (docNo) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/seller-grn-qc-punch/get-seller-grn-qc-punch-by-doc-no/${docNo}`);
        return await response.data;
    } catch (error) {
        console.log("getSellerGRNQCPunchByDocNo - error", error)
        return handleApiError(error)
    }
}

export const getSellerGRNQCPunchBySellerPIPunchId = async (sellerPIPunchId) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/seller-grn-qc-punch//get-grnqc-data-by-seller-pipunch-id/${sellerPIPunchId}`);
        return await response.data;
    } catch (error) {
        console.log("getSellerGRNQCPunchBySellerPIPunchId - error", error)
        return handleApiError(error)
    }
}